<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>

<template>
    <div class="center-table-list">
        <!--     企业法人信息   -->
        <div class="table-list">
            <div class="table-list-title">
                <span style="margin-left:25px">企业法人信息</span>
            </div>
            <div class="enterprise_authentication2_main">
                <ul class="main_group">
                    <li class="main_item">
                        <span class="item_title top_title">上传证件：</span>
                        <div class="item_content">
                            <div class="upload_group">
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="frontalRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="frontalUpLoadBefore"
                                        :on-success="frontalUpLoadSuccess"
                                        :on-error="frontalUpLoadError"
                                        :on-exceeded-size="frontalExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">

                                    <!--  没有图片时  -->
                                    <div v-if="frontalState == -1" class="upload_text">
                                        <img src='./images/Z.png'/>
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="frontalState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="frontalState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="frontalPhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>
                                </Upload>
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="reverseRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic' "
                                        :show-upload-list="false"
                                        :before-upload="reverseUpLoadBefore"
                                        :on-success="reverseUpLoadSuccess"
                                        :on-error="reverseUpLoadError"
                                        :on-exceeded-size="reverseExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">
                                    <!--  没有图片时  -->
                                    <div v-if="reverseState == -1" class="upload_text">
                                        <img src='./images/F.png'/>
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="reverseState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="reverseState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="reversePhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>

                                </Upload>
                                <div class="upload_desc">
                                    <div>上传证件要求：</div>
                                    <ul class="upload_desc_group">
                                        <li>1、上传的证件内容必须清晰可见</li>
                                        <li>2、作者名称和证件号码与提交的证件信息一致</li>
                                        <li>3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨</li>
                                        <li>4、须小于5MB，且为JPG格式，尺寸过小不宜上传(推荐800*600以上）</li>
                                        <li>5、证件在有效期之内</li>
                                    </ul>
                                    <div class="demo_img">
                                        <img src="./images/upload_demo.png" alt='版权登记'>
                                        <ol class="demo_text">
                                            <li>标准</li>
                                            <li style="padding-left: 12px;">边框缺失</li>
                                            <li>照片模糊</li>
                                            <li>闪光强烈</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">法人姓名：</span>
                        <div class="item_content">
                            <i-input v-model="modifyUserName" placeholder="请输入法人姓名"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">证件号：</span>
                        <div class="item_content">
                            <i-input v-model="modifyIdCardNum" placeholder="请输入证件号"></i-input>
                        </div>
                    </li>
                    <!--                    <li class="main_item">-->
                    <!--                        <span class="item_title">国家省市：</span>-->
                    <!--                        <div class="item_content" style="color: #CBCBCB;">-->
                    <!--                            <Select class="item_city_list" v-model="countrySelection">-->
                    <!--                                <Option :value="countrySelection">{{countrySelection}}</Option>-->
                    <!--                            </Select>-->
                    <!--                            —-->
                    <!--                            <Select class="item_city_list" v-model="provincesSelection" @on-change="provinceChange">-->
                    <!--                                <Option v-for="(item,index) in cityData" :value="index">{{index}}</Option>-->
                    <!--                            </Select>-->
                    <!--                            —-->
                    <!--                            <Select class="item_city_list" v-model="citySelection">-->
                    <!--                                <Option v-for="(item,index) in cityData[provincesSelection]" :value="item">{{item}}-->
                    <!--                                </Option>-->
                    <!--                            </Select>-->

                    <!--                        </div>-->
                    <!--                    </li>-->
                    <!--                    <li class="main_item">-->
                    <!--                        <span class="item_title">详细地址：</span>-->
                    <!--                        <div class="item_content">-->
                    <!--                            <i-input v-model="detailedAddress" placeholder="请输入详细地址"></i-input>-->
                    <!--                        </div>-->
                    <!--                    </li>-->
                    <li class="main_item">
                        <span class="item_title">证件有效期：</span>
                        <div class="item_content">
                            <DatePicker class="item_date_list" style="width: 165px;" type="date" placeholder="开始时间"
                                        :value="startTime"
                                        format="yyyy-MM-dd"
                                        @on-change="startTimeChange"
                                        :options="disabledDate[0].start"></DatePicker>
                            <Select v-model="dateTypeValue" @on-change="dateTypeChange" class="item_date_list"
                                    style="width: 175px;height: 48px;">
                                <Option v-for="(item,index) in dateType" :value="item.value">{{item.label}}</Option>
                            </Select>
                            <DatePicker v-show="dateTypeValue!=0" class="item_date_list" style="width: 165px;"
                                        type="date"
                                        :value="dateTypeValue == 0? endTime='长期' : endTime "
                                        placeholder="结束时间"
                                        format="yyyy-MM-dd"
                                        @on-change="endTimeChange"
                                        :options="disabledDate[1].end"></DatePicker>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!--     企业账号委托书   -->
        <div class="table-list">
            <div class="table-list-title">
                <span style="margin-left:25px">企业账号委托书</span>
            </div>
            <div class="enterprise_authentication2_main">
                <ul class="main_group">
                    <li class="main_item">
                        <div class="item_content">
                            <div class="upload_group">
                                <MyUploadOneHw accept=".jpg,.jpeg,.png" :pictureSize="20971520"
                                               @listenImgUrl="showMessageFromChild"></MyUploadOneHw>
                                <div class="upload_desc entrust">
                                    <a class="entrust_link"
                                       href="http://filetemp.bqj.cn/file/b80a3ff770164d3287463ce721d5aea9.docx">下载《企业委托书》模版</a>
                                    <div>说明：</div>
                                    <ul class="upload_desc_group">
                                        <li>步骤一：请下载《企业委托书模版》；</li>
                                        <li>步骤二：法人签名或盖章，并加盖企业公章；</li>
                                        <li>步骤三：请上传.jpg .jpeg .png格式，大小不超过20M；</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </li>
                </ul>
            </div>
        </div>

        <div style="text-align: center;margin:30px 0 5px;">
            <div class="submit_btn" @click="checkSubmit">提交</div>
        </div>
    </div>
</template>

<script>
    import MyUploadOneHw from '@/views/main-components/my-upload-one-hw';
    import {_getProvinceAndCityList, _enterpriseRealNameSecond} from "@/api/authentication.js";
    import {userInfo} from "@/api/index";
    import Cookies from "js-cookie";

    export default {
        metaInfo: {
            title: '企业认证|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '企业认证,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "enterpriseAuthentication2",
        components: {
            MyUploadOneHw
        },
        data() {
            return {
                saveLogin: false, //重置用户是否自动保存
                userName: '', //法人姓名
                modifyUserName: '', //修改后的法人姓名
                idCardNum: '', //法人身份证号
                modifyIdCardNum: '', //修改后的身份证号
                frontalRequestData: {picType: 'idCadeOn'}, //上传身份证正面请求参数
                reverseRequestData: {picType: 'idCadeBack'}, //上传身份证正面请求参数
                frontalFileId: '', //身份证正面照片id
                reverseFileId: '', //身份证反面照片id
                frontalPhoto: '', //身份证正面照片
                reversePhoto: '', //身份证反面照片
                frontalState: -1, //正面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                reverseState: -1, //反面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                // cityData: [], //省份城市列表
                // countrySelection: '中国', //选中国家
                // provincesSelection: '北京', //选中省份
                // citySelection: '北京', //选中城市
                // detailedAddress: '', //详细地址
                disabledDate: [
                    {
                        start: {
                            disabledDate(date) {
                                return date && date.valueOf() > Date.now() - 172800;
                            }
                        }
                    },
                    {
                        end: {
                            disabledDate(date) {
                                return date && date.valueOf() < Date.now() - 8.64e7;
                            }
                        }
                    }
                ], //时间限制条件
                dateType: [
                    {value: 0, label: '无期限'},
                    {value: 1, label: '有期限（请选择日期）'},
                ], //时间下拉框选项
                dateTypeValue: 0, //当前时间选择值
                startTime: '', //证件开始时间
                endTime: '', //证件结束时间
                proxyAttachUrl: '', //委托书图片地址
                btnFlag:true, //防止重复点击
            }
        },
        created() {
            // this.getProvinceAndCityList();
        },
        methods: {
            /****************身份证正面**************/
            frontalUpLoadBefore(file) {
                this.frontalState = 1;
            },
            frontalUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.userName = result.name;
                    this.modifyUserName = result.name;
                    this.frontalFileId = res.fileId;
                    this.frontalPhoto = res.fileUrl;
                    this.idCardNum = result.id;
                    this.modifyIdCardNum = result.id;
                    this.detailedAddress = result.address;
                    this.frontalState = 0;
                } else {
                    this.frontalUpLoadError();
                }
            },
            frontalExceededSize() {
                toast('证件大小不得超过5MB');
                this.frontalUpLoadError(true);
            },
            frontalUpLoadError(showToast) {
                this.frontalFileId = '';
                this.frontalState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************身份证反面**************/
            reverseUpLoadBefore(data) {
                this.reverseState = 1;
            },
            reverseUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.reversePhoto = res.fileUrl;
                    this.reverseFileId = res.fileId;
                    this.startTime = result.validStart;
                    if (result.validEnd != '长期') {
                        this.endTime = result.validEnd;
                        this.dateTypeValue = 1;
                    } else {
                        this.dateTypeValue = 0;
                    }
                    this.reverseState = 0;
                } else {
                    this.reverseUpLoadError();
                }
            },
            reverseExceededSize() {
                toast('证件大小不得超过5MB');
                this.reverseUpLoadError(true);
            },
            reverseUpLoadError(showToast) {
                this.reverseFileId = '';
                this.reverseState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************获取省市列表接口数据**************/
            getProvinceAndCityList() {
                _getProvinceAndCityList().then(res => {
                    if (res) {
                        this.cityData = res;
                    }
                });

            },
            provinceChange(value) {
                this.citySelection = this.cityData[value][0];
            },

            /****************证件有效期开始时间**************/
            startTimeChange(value) {
                this.startTime = value;
            },

            /****************证件有效期结束时间**************/
            endTimeChange(value) {
                this.endTime = value;
            },

            /****************证件是否长期有效的改变事件**************/
            dateTypeChange(value) {
                this.endTime = '';
            },

            /****************接收华为云上传组件传过来的图片地址**************/
            showMessageFromChild(data) {
                if (data) {
                    this.proxyAttachUrl = data;
                }
            },

            /****************提交点击事件**************/
            checkSubmit() {
                if(!this.btnFlag){
                    return
                }
                if (this.modifyUserName != '' && this.modifyIdCardNum != '' && this.frontalFileId != '' && this.reverseFileId != '' && this.startTime != '' && this.endTime != '' && this.proxyAttachUrl != '') {
                    this.btnFlag = false;

                    let _userInfo = JSON.parse(Cookies.get("userInfo"));
                    let data = {
                        registerId: _userInfo.id,
                        legalName: this.userName,
                        modifyLegalName: this.modifyUserName,
                        legalIdentityNo: this.idCardNum,
                        modifyLegalIdentityNo: this.modifyIdCardNum,
                        legalPicCardOn: this.frontalFileId,
                        legalPicCardBack: this.reverseFileId,
                        legalStartTime: this.startTime,
                        legalEndTime: this.endTime,
                        proxyAttachUrl:this.proxyAttachUrl,
                        // address: this.detailedAddress,
                    };

                    _enterpriseRealNameSecond(data).then(res => {
                        console.log(res);
                        if (res.code == 200) {

                            // 获取用户信息
                            userInfo().then(res => {
                                if (res.code == 200) {
                                    // 避免超过大小限制
                                    if (this.saveLogin) {
                                        // 保存7天
                                        Cookies.set("userInfo", JSON.stringify(res.result), {
                                            expires: 7
                                        });
                                    } else {
                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                    }
                                    this.setStore("userInfo", res.result);
                                    let photo = res.result.photo ? res.result.photo : '';
                                    this.$store.commit("setAvatarPath", photo);

                                    this.$router.push("/obligee");
                                } else {
                                    toast('认证失败，请重试');
                                }
                            });

                        } else {
                            toast(res.message);
                        }
                        this.btnFlag = true;
                    }, (err) => {
                        toast('提交失败，请重试');
                        console.log(err);
                        this.btnFlag = true;
                    })

                } else {
                    toast('请填写完整后再提交');
                }
            }

        }
    }
</script>

<style scoped lang="less">
    .center-table-list .table-list {
        height: 100%;
    }

    .main_group .main_item {
        display: flex;
        border-bottom: 1px solid #F3F3F3;
        padding: 20px 35px;
        color: #666;
        font-size: 14px;
    }

    .main_item .item_title {
        width: 130px;
        align-self: center;
    }

    .main_item .item_title.top_title {
        align-self: auto;
    }

    .main_item .item_content {
        flex: 1;
    }

    .item_content .selection_box:before {
        content: '';
        width: 12px;
        height: 12px;
        background: #FFD800;
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        margin-top: -3px;
    }

    .upload_group .upload_desc {
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
    }

    .upload_desc.entrust {
        padding-top: 0;
    }

    .entrust .entrust_link {
        text-decoration: underline;
        color: #4E8CEE;
        margin: 12px 0 18px;
        display: inline-block;
    }

    .upload_desc .demo_img {
        width: 327px;
        padding-top: 14px;
    }

    .upload_desc .demo_text {
        width: 335px;
        color: #666666;
        font-size: 12px;
        font-weight: bold;
        padding-top: 4px;
        display: flex;
        justify-content: space-around;
        list-style: none;
    }

    .demo_img img {
        display: block;
        width: 100%;
        height: 48px;
    }

    .upload_desc .upload_desc_group {
        list-style: none;
        padding-top: 5px;
    }

    /deep/ .ivu-input {
        width: 400px;
        height: 48px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 14px;
        line-height: 48px;
        color: #333;
        padding: 0 10px;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }


    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }


    /deep/ .ivu-upload {
        width: 180px;
        height: 110px;
        margin-right: 20px;
        display: flex;
    }

    /deep/ .vertical_upload.ivu-upload {
        width: 130px;
        height: 160px;
    }

    /deep/ .vertical_upload .ivu-upload {
        width: 130px;
        height: 160px;
    }

    /deep/ .ivu-upload-drag {
        border: 1px solid #CBCBCB;
    }

    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
        img{
            width: 162px;
            height: 81px;
            display: block;
            margin: auto;
        }
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .upload_success:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 2;
    }

    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: rgba(255, 216, 0, 1);
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #4E4E4E;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #cf7700;
        border-color: #cf7700;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }

    /deep/ .ivu-date-picker .ivu-input {
        width: 100%;
    }

    /deep/ .item_date_list .ivu-input-suffix i {
        line-height: 48px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    .item_content .item_city_list {
        width: 140px;
        height: 32px;
        /*margin-right: 35px;*/
    }

    .item_content .item_city_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_city_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        text-align: center;
        color: #333333;
    }


    /deep/ .item_date_list.ivu-select-single .ivu-select-selection {
        height: 48px;
        border-radius: 2px;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
        height: 48px;
        line-height: 48px;
        color: #999999;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
        line-height: 48px;
    }

    .submit_btn {
        width: 230px;
        height: 42px;
        line-height: 42px;
        background: #FFD800;
        color: #4E4E4E;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        display: inline-block;
        border-radius: 4px;
        cursor: pointer;
    }

</style>